const CalculatorSkeleton = ({ isDarkMode }) => {
  return (
    <div className="max-w-6xl px-3 py-4 mx-auto sm:px-4">
     

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
        {/* Left Side Skeleton */}
        <div className="space-y-4 lg:col-span-2">
          {[1, 2].map((categoryIdx) => (
            <div
              key={categoryIdx}
              className={`p-3 rounded-lg ${isDarkMode ? "bg-gray-800" : "bg-white shadow-sm"}`}
            >
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-1.5">
                  <div
                    className={`w-2 h-2 rounded-full ${isDarkMode ? "bg-gray-600" : "bg-gray-300"} animate-pulse`}
                  ></div>
                  <div
                    className={`w-24 h-4 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"} animate-pulse`}
                  ></div>
                </div>
                <div
                  className={`w-16 h-4 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"} animate-pulse`}
                ></div>
              </div>
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
                {[1, 2, 3, 4].map((faultIdx) => (
                  <div
                    key={faultIdx}
                    className={`p-3 rounded-lg ${isDarkMode ? "bg-gray-700" : "bg-gray-100"} animate-pulse`}
                  >
                    <div className="flex flex-col items-center gap-2">
                      <div
                        className={`w-10 h-10 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-400"}`}
                      ></div>
                      <div
                        className={`w-16 h-3 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-400"}`}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}

          {/* Step Info Skeleton */}
          <div className="flex justify-center">
            <div
              className={`w-32 h-3 rounded ${isDarkMode ? "bg-gray-600" : "bg-gray-300"} animate-pulse`}
            ></div>
          </div>

          {/* Navigation Buttons Skeleton */}
          <div className="flex gap-3">
            <div
              className={`flex-1 h-10 rounded-lg ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
            ></div>
            <div
              className={`flex-1 h-10 rounded-lg ${isDarkMode ? "bg-emerald-800/50" : "bg-emerald-500/30"} animate-pulse`}
            ></div>
          </div>
        </div>

        {/* Right Side - Device Info Card Skeleton */}
        <div className="lg:col-span-1">
          <div
            className={`sticky top-20 rounded-lg overflow-hidden ${isDarkMode ? "bg-gray-800" : "bg-white shadow-sm"}`}
          >
            <div
              className={`p-4 text-center border-b ${isDarkMode ? "border-gray-700" : "border-gray-100"}`}
            >
              <div
                className={`w-28 h-28 mx-auto mb-3 rounded-lg ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
              ></div>
              <div
                className={`w-32 h-5 mx-auto mb-2 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
              ></div>
              <div
                className={`w-24 h-3 mx-auto rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
              ></div>
            </div>
            <div className="p-4 space-y-3">
              <div className="flex items-center justify-between">
                <div
                  className={`w-16 h-3 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
                ></div>
                <div
                  className={`w-24 h-3 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
                ></div>
              </div>
              <div className="flex items-center justify-between">
                <div
                  className={`w-16 h-3 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
                ></div>
                <div
                  className={`w-8 h-3 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
                ></div>
              </div>
            </div>
            <div
              className={`h-px ${isDarkMode ? "bg-gray-700" : "bg-gray-100"}`}
            ></div>
            <div className="p-4 text-center">
              <div
                className={`w-24 h-3 mx-auto rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
              ></div>
              <div
                className={`w-40 h-3 mx-auto mt-2 rounded ${isDarkMode ? "bg-gray-700" : "bg-gray-200"} animate-pulse`}
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CalculatorSkeleton;
